import { getFieldOnMainLanguage } from '@app/utils/languages';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';

import { GenericObject } from '@app/components/common/Table/DefaultTable/types';

import './styles.css';

interface SelectFormatterProps {
  value: GenericObject;
}

export const SelectFormatter = ({ value }: SelectFormatterProps) => {
  return (
    <div className="select-formatter-container">
      <span>{value?.name ? getFieldOnMainLanguage(value?.name) : ''} </span>
      <ArrowDropDownIcon sx={{ justifySelf: 'flex-end' }} />
    </div>
  );
};
